import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { jwtDecode } from 'jwt-decode';
import { IdentityStorage } from 'storage-service-lib';

const EMBED_URL_API = 'https://chbtya5o5c.execute-api.eu-west-1.amazonaws.com/prod/embed-url';
const AGENT_ID = '228cc386-9da1-4b6d-8556-54249c614e1e';

interface BullhornJwt {
  BhRestToken: string;
  restUrl: string;
  userId: string;
  corporationId: string;
  name: string;
}

@Component({
  selector: 'app-bw-mcp-chat',
  templateUrl: './bw-mcp-chat.component.html',
  styleUrl: './bw-mcp-chat.component.scss',
  imports: [CommonModule],
})
export class BwMcpChatComponent implements OnInit {
  @ViewChild('chatContainer', { static: true }) chatContainer!: ElementRef;

  private http = inject(HttpClient);
  private identityStorage = inject(IdentityStorage);

  error = '';
  loading = true;

  async ngOnInit(): Promise<void> {
    try {
      const token = this.identityStorage.get()?.token;
      const decoded = token ? jwtDecode<BullhornJwt>(token) : null;

      console.log('[BwMcpChat] Requesting embed URL for user:', decoded?.name ?? 'unknown');

      const { embedUrl, sessionId } = await firstValueFrom(
        this.http.post<{ embedUrl: string; sessionId: string }>(EMBED_URL_API, {
          bhRestToken: decoded?.BhRestToken,
          restUrl: decoded?.restUrl,
          userId: decoded?.userId,
          corpId: decoded?.corporationId,
          displayName: decoded?.name,
        }),
      );

      console.log('[BwMcpChat] Embed URL received, sessionId:', sessionId);

      const context = await createEmbeddingContext();
      await context.embedQuickChat(
        {
          url: embedUrl,
          container: this.chatContainer.nativeElement,
          height: '100%',
          width: '100%',
        },
        {
          agentOptions: { fixedAgentId: AGENT_ID },
          promptOptions: {
            allowFileAttachments: false,
            showAgentKnowledgeBoundary: false,
            showChatHistory: false,
            showWebSearch: false,
            enablePrivateMode: false,
          },
          footerOptions: { showBrandAttribution: false, showUsagePolicy: false },
          onMessage: async (msg: unknown) => {
            console.log('[BwMcpChat] message:', msg);
            const event = msg as { eventName?: string };
            if (event?.eventName === 'EXPERIENCE_INITIALIZED') {
              this.loading = false;
            }
          },
        },
      );
    } catch (err) {
      this.error = 'Failed to load chat agent.';
      console.error('[BwMcpChat] Error:', err);
      this.loading = false;
    }
  }
}
